import { useLocation, useParams } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export const useEventScope = () => {
  const { pathname } = useLocation();
  const { id: eventId } = useParams();
  return { isEventScope: pathname.includes('events'), eventId };
};
